/**
 * Created by mh on 2017/4/5.
 */
import React, { Component } from 'react';
import { observer } from 'mobx-react';

import SignupForm from './forms/definitions/SignupForm';
import FormSignup from './forms/FormSignup';

@observer
export default class SignUp extends Component {
    render() {
        // const { username, password } = this.props;
        return (
            <div className="row">
                <div className="col-12 signin">

                    <FormSignup className="form-signin" form={SignupForm} />

                </div>
            </div>
        );
    }
}
